import controller from './related-products.controller';
import template from './related-products.view.html';

let RelatedProductsComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<',
    productRelatedId : '<'
  }
};

export default RelatedProductsComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/related-products/related-products.component.js
 **/